import React from "react";
import { YU_COLOURS } from "../../../..";
export var Hamburger = function (_a) {
    var className = _a.className, title = _a.title, width = _a.width, height = _a.height, fill = _a.fill;
    return (React.createElement("svg", { className: className, width: width, height: height, fill: "none", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24" },
        React.createElement("title", null, title),
        React.createElement("path", { d: "M22.5 12h-21a.5.5 0 0 0 0 1h21a.5.5 0 0 0 0-1ZM22.5 5h-21a.5.5 0 0 0 0 1h21a.5.5 0 0 0 0-1ZM22.5 19h-21a.5.5 0 0 0 0 1h21a.5.5 0 0 0 0-1Z", fill: fill || YU_COLOURS.N200 })));
};
